// 🔑 THE DOCUMENTS PAGE (cleanup Phase 2, Jesse 2026-10-28/29): every borrower gets the guided Documents page — the home
// for the application (components/GuidedDocuments). The classic page that used to sit here is gone.
import React from 'react';
import AppShell from '../components/AppShell';
import GuidedDocuments from '../components/GuidedDocuments';
import { useAuth } from '../context/AuthContext';

function Documents() {
  const { token } = useAuth();
  return <AppShell><GuidedDocuments token={token} /></AppShell>;
}

export default Documents;
